export default __webpack_public_path__ + "static/media/flow-logo.ec5c31b7.svg";